var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    id: "active"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8.71429H5.53846L7.46154 4L10.5385 13L12.4615 8.71429H14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    id: "frozen"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 2.8125V15.1875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64209 5.90625L14.3577 12.0938",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.64209 12.0938L14.3577 5.90625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    id: "done"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09375 10.0758V3.65625C3.09375 3.50707 3.15301 3.36399 3.2585 3.2585C3.36399 3.15301 3.50707 3.09375 3.65625 3.09375H14.3438C14.4929 3.09375 14.636 3.15301 14.7415 3.2585C14.847 3.36399 14.9062 3.50707 14.9062 3.65625V14.3438C14.9062 14.4929 14.847 14.636 14.7415 14.7415C14.636 14.847 14.4929 14.9062 14.3438 14.9062H9.53438",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10.6875L4.5 15.1875L2.25 12.9375",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 6",
    id: "menu-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.207293 0.31094L3.83359 5.75038C3.91275 5.86913 4.08725 5.86913 4.16641 5.75038L7.79271 0.31094C7.88131 0.178029 7.78604 0 7.6263 0H0.373703C0.213964 0 0.118686 0.178029 0.207293 0.31094Z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    id: "notif"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3044 14.25C13.5568 12.383 13.4084 10.7627 13.55 9.14112C13.8074 6.19206 11.9058 3.75 9.14629 3.75C6.36005 3.75 4.45006 6.24587 4.6717 9.25711C4.78861 10.8454 4.61231 12.4284 3.87682 14.25H14.3044ZM9.14629 3C5.81188 3 3.67896 5.98675 3.92372 9.31216C4.03963 10.8869 3.84985 12.4477 3.04226 14.3005C2.90077 14.6251 3.13126 15 3.48535 15H14.6818C15.0414 15 15.2757 14.6192 15.133 14.2891C14.3182 12.404 14.1569 10.8134 14.2971 9.20633C14.5838 5.92209 12.443 3 9.14629 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.56534 2.43653C8.43838 2.54939 8.33964 2.72676 8.33964 3.00001C8.33964 3.20711 8.17175 3.37501 7.96464 3.37501C7.75753 3.37501 7.58964 3.20711 7.58964 3.00001C7.58964 2.52325 7.77215 2.13812 8.06706 1.87597C8.35507 1.61996 8.72849 1.5 9.08964 1.5C9.45079 1.5 9.8242 1.61996 10.1122 1.87597C10.4071 2.13812 10.5896 2.52325 10.5896 3.00001C10.5896 3.20711 10.4217 3.37501 10.2146 3.37501C10.0075 3.37501 9.83964 3.20711 9.83964 3.00001C9.83964 2.72676 9.7409 2.54939 9.61394 2.43653C9.48008 2.31754 9.29099 2.25 9.08964 2.25C8.88829 2.25 8.6992 2.31754 8.56534 2.43653Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.56534 15.5635C8.43838 15.4506 8.33964 15.2732 8.33964 15C8.33964 14.7929 8.17175 14.625 7.96464 14.625C7.75753 14.625 7.58964 14.7929 7.58964 15C7.58964 15.4768 7.77215 15.8619 8.06706 16.124C8.35507 16.38 8.72849 16.5 9.08964 16.5C9.45079 16.5 9.8242 16.38 10.1122 16.124C10.4071 15.8619 10.5896 15.4768 10.5896 15C10.5896 14.7929 10.4217 14.625 10.2146 14.625C10.0075 14.625 9.83964 14.7929 9.83964 15C9.83964 15.2732 9.7409 15.4506 9.61394 15.5635C9.48008 15.6825 9.29099 15.75 9.08964 15.75C8.88829 15.75 8.6992 15.6825 8.56534 15.5635Z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    version: 1.1,
    id: "plus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    xmlSpace: "preserve",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,9H5 M9,5v7.7"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    id: "logout"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2344 6.04688L15.1875 9L12.2344 11.9531",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 9H15.1875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 15.1875H3.375C3.22582 15.1875 3.08274 15.1282 2.97725 15.0227C2.87176 14.9173 2.8125 14.7742 2.8125 14.625V3.375C2.8125 3.22582 2.87176 3.08274 2.97725 2.97725C3.08274 2.87176 3.22582 2.8125 3.375 2.8125H7.3125",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "settings"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0761 3.16311C10.136 2.50438 10.6883 2 11.3497 2H12.6503C13.3117 2 13.864 2.50438 13.9239 3.16311C13.9731 3.70392 14.3623 4.14543 14.8708 4.336C15.0015 4.38499 15.1307 4.43724 15.2582 4.49263C15.7613 4.71129 16.3531 4.66938 16.7745 4.31818C17.2953 3.8842 18.0611 3.91894 18.5404 4.39829L19.4584 5.31623C19.9154 5.77326 19.9485 6.50338 19.5347 6.99992C19.1901 7.41349 19.158 7.99745 19.3897 8.48341C19.49 8.69386 19.5816 8.90926 19.664 9.12916C19.8546 9.63767 20.2961 10.0269 20.8369 10.0761C21.4956 10.136 22 10.6883 22 11.3497V12.6503C22 13.3117 21.4956 13.864 20.8369 13.9239C20.2961 13.9731 19.8546 14.3623 19.664 14.8708C19.59 15.0682 19.5086 15.262 19.4202 15.4518C19.2053 15.913 19.2401 16.4637 19.5658 16.8546C19.962 17.33 19.9303 18.0291 19.4927 18.4667L18.4667 19.4927C18.0291 19.9303 17.33 19.962 16.8546 19.5658C16.4637 19.2401 15.913 19.2053 15.4518 19.4202C15.262 19.5086 15.0682 19.59 14.8708 19.664C14.3623 19.8546 13.9731 20.2961 13.9239 20.8369C13.864 21.4956 13.3117 22 12.6503 22H11.3497C10.6883 22 10.136 21.4956 10.0761 20.8369C10.0269 20.2961 9.63767 19.8546 9.12917 19.664C8.90927 19.5816 8.69387 19.49 8.48343 19.3897C7.99746 19.158 7.4135 19.1901 6.99992 19.5347C6.50338 19.9485 5.77325 19.9154 5.31622 19.4584L4.39829 18.5404C3.91893 18.0611 3.8842 17.2953 4.31818 16.7745C4.66939 16.3531 4.71129 15.7613 4.49263 15.2582C4.43724 15.1307 4.385 15.0016 4.336 14.8708C4.14544 14.3623 3.70392 13.9731 3.16311 13.9239C2.50438 13.864 2 13.3117 2 12.6503V11.3497C2 10.6883 2.50438 10.136 3.16311 10.0761C3.70393 10.0269 4.14544 9.63768 4.33601 9.12917C4.3936 8.9755 4.45568 8.82402 4.52209 8.67489C4.7571 8.14716 4.71804 7.52257 4.34821 7.07877C3.89722 6.53758 3.93332 5.74179 4.43145 5.24365L5.24364 4.43146C5.74178 3.93332 6.53757 3.89722 7.07876 4.34822C7.52256 4.71805 8.14715 4.7571 8.67488 4.52209C8.82401 4.45568 8.97549 4.3936 9.12916 4.33601C9.63767 4.14544 10.0269 3.70393 10.0761 3.16311Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 12",
    id: "support"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99972 1.09091C10.1012 1.09091 12.6245 3.05018 12.6245 5.45836C12.6245 8.14036 9.73054 9.80073 7.05034 9.80073C5.96082 9.80073 5.14748 9.58418 4.57882 9.44945C4.01634 9.78382 3.68167 10.0151 2.17592 10.4422C2.47684 9.69327 2.58259 8.94327 2.51453 8.11582C2.04318 7.57036 1.37552 6.80673 1.37552 5.45836C1.37495 3.05018 3.89822 1.09091 6.99972 1.09091ZM6.99972 0C3.43474 0 0.25 2.30509 0.25 5.45836C0.25 6.57655 0.665108 7.67455 1.40139 8.52655C1.43233 9.52473 0.825976 10.9571 0.280374 12C1.74394 11.7436 3.82454 11.1775 4.76781 10.6167C5.5654 10.8049 6.32868 10.8911 7.0509 10.8911C11.0355 10.8911 13.75 8.25273 13.75 5.45782C13.7494 2.28818 10.5428 0 6.99972 0ZM7.5757 7.62273C7.5757 7.93146 7.31808 8.18182 6.99972 8.18182C6.68192 8.18182 6.42374 7.93146 6.42374 7.62273C6.42374 7.31455 6.68192 7.06418 6.99972 7.06418C7.31808 7.06418 7.5757 7.31455 7.5757 7.62273ZM8.21748 3.15436C7.93737 2.87891 7.51945 2.72727 7.0419 2.72727C6.03732 2.72727 5.38766 3.42055 5.38766 4.49291H6.31406C6.31406 3.82909 6.69654 3.59345 7.02334 3.59345C7.31527 3.59345 7.62519 3.78164 7.65163 4.14109C7.68088 4.51964 7.4722 4.71164 7.2084 4.95545C6.55761 5.55545 6.54524 5.84618 6.54861 6.50564H7.47276C7.46714 6.20891 7.48682 5.96782 7.90362 5.532C8.21579 5.20582 8.6039 4.8 8.61178 4.18091C8.61628 3.76745 8.48072 3.41236 8.21748 3.15436Z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    id: "more"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 10.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 10.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 10.5,
    r: 1.5
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    id: "move-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 9V5.13333C1 4.02876 1.89543 3.13333 3 3.13333H9M9 3.13333L7 1M9 3.13333L7 5.26667",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 8",
    id: "checked"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 3L4.6 7L10 1",
    strokeLinecap: "round"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 10",
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58579 1L1.29289 9.29289M1 1L9.29289 9.29289",
    strokeLinecap: "round"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 10",
    id: "arrow-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1L5 5L1 9",
    strokeLinecap: "round"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    id: "folder"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 42.25V13C6.5 12.569 6.67121 12.1557 6.97595 11.851C7.2807 11.5462 7.69402 11.375 8.125 11.375H18.9516C19.3029 11.3764 19.6446 11.4903 19.9266 11.7L25.5734 15.925C25.8554 16.1347 26.1971 16.2486 26.5484 16.25H40.625C41.056 16.25 41.4693 16.4212 41.774 16.726C42.0788 17.0307 42.25 17.444 42.25 17.875V22.75",
    fill: "#C2C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 42.25L12.5938 27.0156C12.7126 26.7145 12.9198 26.4563 13.188 26.275C13.4563 26.0938 13.7731 25.9979 14.0969 26H23.8875C24.2041 25.9966 24.5136 25.9052 24.7812 25.7359L28.8438 23.0141C29.1114 22.8448 29.4209 22.7534 29.7375 22.75H46.4953C46.7523 22.75 47.0056 22.8109 47.2344 22.9277C47.4633 23.0446 47.6611 23.2141 47.8118 23.4222C47.9625 23.6304 48.0616 23.8713 48.1011 24.1252C48.1406 24.3791 48.1194 24.6387 48.0391 24.8828L42.25 42.25H6.5Z",
    fill: "#E2DFFF"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 5",
    id: "arrow-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.35355 0.646447C1.15829 0.451184 0.841709 0.451184 0.646447 0.646447C0.451184 0.841709 0.451184 1.15829 0.646447 1.35355L1.35355 0.646447ZM4 4L3.64645 4.35355L4 4.70711L4.35355 4.35355L4 4ZM7.35355 1.35355C7.54882 1.15829 7.54882 0.841709 7.35355 0.646447C7.15829 0.451184 6.84171 0.451184 6.64645 0.646447L7.35355 1.35355ZM0.646447 1.35355L3.64645 4.35355L4.35355 3.64645L1.35355 0.646447L0.646447 1.35355ZM4.35355 4.35355L7.35355 1.35355L6.64645 0.646447L3.64645 3.64645L4.35355 4.35355Z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 6",
    id: "square"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 14",
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57896 5.48502C9.57896 8.06441 7.53626 10.1365 5.03948 10.1365C2.5427 10.1365 0.5 8.06441 0.5 5.48502C0.5 2.90563 2.5427 0.833496 5.03948 0.833496C7.53626 0.833496 9.57896 2.90563 9.57896 5.48502Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 4.72264,
    y2: -0.5,
    transform: "matrix(0.69929 0.714838 -0.69929 0.714838 8.3479 9.93359)",
    strokeLinecap: "round"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 12",
    id: "filter-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6H14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H17",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11H11",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    id: "delete"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.875 4.375H3.125",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 8.125V13.125",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 8.125V13.125",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625 4.375V16.25C15.625 16.4158 15.5592 16.5747 15.4419 16.6919C15.3247 16.8092 15.1658 16.875 15 16.875H5C4.83424 16.875 4.67527 16.8092 4.55806 16.6919C4.44085 16.5747 4.375 16.4158 4.375 16.25V4.375",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 4.375V3.125C13.125 2.79348 12.9933 2.47554 12.7589 2.24112C12.5245 2.0067 12.2065 1.875 11.875 1.875H8.125C7.79348 1.875 7.47554 2.0067 7.24112 2.24112C7.0067 2.47554 6.875 2.79348 6.875 3.125V4.375",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    id: "duplicate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 17.5H4.375C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875V5.625C3.75 5.45924 3.81585 5.30027 3.93306 5.18306C4.05027 5.06585 4.20924 5 4.375 5H10.625L13.75 8.125V16.875C13.75 17.0408 13.6842 17.1997 13.5669 17.3169C13.4497 17.4342 13.2908 17.5 13.125 17.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 5V3.125C6.25 2.95924 6.31585 2.80027 6.43306 2.68306C6.55027 2.56585 6.70924 2.5 6.875 2.5H13.125L16.25 5.625V14.375C16.25 14.5408 16.1842 14.6997 16.0669 14.8169C15.9497 14.9342 15.7908 15 15.625 15H13.75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 11.875H10.625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 14.375H10.625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    id: "send"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.87508 10.5388L13.8985 16.7185C13.9797 16.7904 14.0781 16.8399 14.1842 16.8622C14.2903 16.8845 14.4004 16.8788 14.5036 16.8457C14.6068 16.8126 14.6997 16.7532 14.773 16.6734C14.8464 16.5936 14.8977 16.4961 14.922 16.3904L17.8595 3.56228C17.8841 3.4518 17.8783 3.33671 17.8426 3.22929C17.8069 3.12187 17.7427 3.02615 17.6569 2.95236C17.5711 2.87857 17.4668 2.82946 17.3553 2.8103C17.2437 2.79113 17.1291 2.80261 17.0235 2.84353L2.60164 8.50759C2.02352 8.73415 2.10164 9.5779 2.71102 9.7029L6.87508 10.5388Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 10.5386L17.5078 2.85889",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3828 13.6255L7.94531 16.063C7.85835 16.1513 7.7471 16.2117 7.62571 16.2367C7.50431 16.2616 7.37824 16.2499 7.26352 16.203C7.1488 16.1561 7.05061 16.0761 6.98143 15.9733C6.91225 15.8705 6.87521 15.7494 6.875 15.6255V10.5396",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5H7.5V10L15 2.5L17.5 5L10 12.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 4.375L15.625 6.875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 9.375V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V3.75C3.125 3.58424 3.19085 3.42527 3.30806 3.30806C3.42527 3.19085 3.58424 3.125 3.75 3.125H10.625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    id: "editSent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5H7.5V10L15 2.5L17.5 5L10 12.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 4.375L15.625 6.875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 9.375V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V3.75C3.125 3.58424 3.19085 3.42527 3.30806 3.30806C3.42527 3.19085 3.58424 3.125 3.75 3.125H10.625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    id: "cancel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04883 3.04883L12.9509 12.9509",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 12",
    id: "archive"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.9375H1.25C0.93934 0.9375 0.6875 1.18934 0.6875 1.5V3.1875C0.6875 3.49816 0.93934 3.75 1.25 3.75H14.75C15.0607 3.75 15.3125 3.49816 15.3125 3.1875V1.5C15.3125 1.18934 15.0607 0.9375 14.75 0.9375Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 3.75V10.5C14.1875 10.6492 14.1282 10.7923 14.0227 10.8977C13.9173 11.0032 13.7742 11.0625 13.625 11.0625H2.375C2.22582 11.0625 2.08274 11.0032 1.97725 10.8977C1.87176 10.7923 1.8125 10.6492 1.8125 10.5V3.75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3125 6.5625H9.6875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 16",
    id: "hide"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5025 12.7845C8.31503 12.8009 6.03997 11.3957 3.00241 8.24001C5.93642 5.19999 8.17265 3.79399 10.367 3.78466C12.5658 3.77531 14.9004 5.16654 18.0331 8.24441C14.9771 11.3272 12.6923 12.768 10.5025 12.7845Z",
    stroke: "#787680"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5248,
    cy: 8.18027,
    r: 2.47167,
    transform: "rotate(-60 10.5248 8.18027)",
    fill: "#787680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3366 3.05134L19.7462 2.76455L19.4594 2.35497L18.8858 1.53582L18.599 1.12624L18.1894 1.41303L1.71321 12.9498L1.30364 13.2366L1.59042 13.6462L2.164 14.4653L2.45079 14.8749L2.86036 14.5881L19.3366 3.05134Z",
    fill: "#787680",
    stroke: "white"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 10",
    id: "show"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.19096 9.49978C6.0035 9.51625 3.72844 8.111 0.690882 4.95535C3.6249 1.91532 5.86112 0.509318 8.05551 0.499991C10.2542 0.490647 12.5889 1.88187 15.7216 4.95974C12.6655 8.04251 10.3808 9.4833 8.19096 9.49978Z",
    stroke: "#787680"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.21328,
    cy: 4.89511,
    r: 2.47167,
    transform: "rotate(-60 8.21328 4.89511)",
    fill: "#787680"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    id: "error"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#A80710"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89855 3L8.72464 9.98639H7.23188L7.05072 3H8.89855ZM7 12.1293C7 11.8798 7.08696 11.6712 7.26087 11.5034C7.43961 11.3311 7.68599 11.2449 8 11.2449C8.30918 11.2449 8.55314 11.3311 8.73188 11.5034C8.91063 11.6712 9 11.8798 9 12.1293C9 12.3696 8.91063 12.576 8.73188 12.7483C8.55314 12.9161 8.30918 13 8 13C7.68599 13 7.43961 12.9161 7.26087 12.7483C7.08696 12.576 7 12.3696 7 12.1293Z",
    fill: "#A80710"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21",
    id: "send-request"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.87484 11.0393L13.8983 17.219C13.9794 17.2909 14.0779 17.3404 14.184 17.3627C14.2901 17.385 14.4001 17.3793 14.5034 17.3462C14.6066 17.3131 14.6994 17.2537 14.7728 17.1739C14.8461 17.0941 14.8975 16.9965 14.9217 16.8909L17.8592 4.06277C17.8838 3.95229 17.878 3.8372 17.8423 3.72978C17.8067 3.62236 17.7425 3.52664 17.6567 3.45285C17.5708 3.37905 17.4666 3.32995 17.355 3.31078C17.2435 3.29162 17.1288 3.3031 17.0233 3.34402L2.6014 9.00808C2.02328 9.23464 2.1014 10.0784 2.71078 10.2034L6.87484 11.0393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3828 14.125L7.94531 16.5625C7.85835 16.6508 7.7471 16.7113 7.62571 16.7362C7.50431 16.7611 7.37824 16.7494 7.26352 16.7025C7.1488 16.6556 7.05061 16.5757 6.98143 16.4728C6.91225 16.37 6.87521 16.2489 6.875 16.125V11.0391",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11L17.5 3.5",
    stroke: "#5B95DE",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 13",
    id: "sort"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8285 0.785831C5.90618 0.656364 6.09382 0.656363 6.1715 0.785831L8.81826 5.1971C8.89824 5.33041 8.80222 5.5 8.64676 5.5H3.35324C3.19778 5.5 3.10176 5.33041 3.18174 5.1971L5.8285 0.785831Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8285 12.2142C5.90618 12.3436 6.09382 12.3436 6.1715 12.2142L8.81826 7.8029C8.89824 7.66959 8.80222 7.5 8.64676 7.5H3.35324C3.19778 7.5 3.10176 7.66959 3.18174 7.8029L5.8285 12.2142Z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    id: "list-type"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.7586L14.1458 19L22 11",
    stroke: "white",
    strokeLinecap: "round"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 16",
    id: "pass-hidden"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5025 12.7845C8.31503 12.8009 6.03997 11.3957 3.00241 8.24001C5.93642 5.19999 8.17265 3.79399 10.367 3.78466C12.5658 3.77531 14.9004 5.16654 18.0331 8.24441C14.9771 11.3272 12.6923 12.768 10.5025 12.7845Z",
    stroke: "#787680"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5248,
    cy: 8.1799,
    r: 2.47167,
    transform: "rotate(-60 10.5248 8.1799)",
    fill: "#787680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3366 3.05097L19.7462 2.76418L19.4594 2.35461L18.8858 1.53545L18.599 1.12588L18.1894 1.41267L1.71321 12.9494L1.30364 13.2362L1.59042 13.6458L2.164 14.4649L2.45079 14.8745L2.86036 14.5877L19.3366 3.05097Z",
    fill: "#787680",
    stroke: "white"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 11",
    id: "pass-visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50248 9.78445C6.31503 9.80092 4.03997 8.39567 1.00241 5.24001C3.93642 2.19999 6.17265 0.793986 8.36703 0.784659C10.5658 0.775315 12.9004 2.16654 16.0331 5.24441C12.9771 8.32718 10.6923 9.76796 8.50248 9.78445Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5248,
    cy: 5.1799,
    r: 1.97167,
    transform: "rotate(-60 8.5248 5.1799)",
    fill: "#2112A2",
    stroke: "black"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 6",
    id: "checkbox-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 2.45455L3.33333 5L7 1",
    stroke: "white",
    strokeLinecap: "round"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25383 11.0017L10.1613 12.9209C10.5363 13.1668 10.9978 12.801 10.8882 12.3511L10.0459 8.90854C10.0232 8.81312 10.0268 8.71294 10.0564 8.61957C10.086 8.52619 10.1403 8.44341 10.2132 8.38076L12.8207 6.11968C13.1611 5.8258 12.988 5.23204 12.5438 5.20205L9.14022 4.97414C9.04736 4.96853 8.95807 4.93491 8.88329 4.87739C8.8085 4.81987 8.75145 4.74096 8.7191 4.65028L7.44997 1.32763C7.41637 1.23161 7.35517 1.14867 7.27467 1.09005C7.19417 1.03144 7.09828 1 7 1C6.90172 1 6.80583 1.03144 6.72533 1.09005C6.64483 1.14867 6.58363 1.23161 6.55003 1.32763L5.2809 4.65028C5.24855 4.74096 5.1915 4.81987 5.11671 4.87739C5.04193 4.93491 4.95264 4.96853 4.85978 4.97414L1.45618 5.20205C1.01199 5.23204 0.838922 5.8258 1.17928 6.11968L3.78678 8.38076C3.85966 8.44341 3.91403 8.52619 3.94363 8.61957C3.97323 8.71294 3.97685 8.81312 3.95407 8.90854L3.17529 12.0992C3.0426 12.639 3.59641 13.0768 4.04061 12.783L6.74617 11.0017C6.82204 10.9515 6.91009 10.9249 7 10.9249C7.08991 10.9249 7.17796 10.9515 7.25383 11.0017V11.0017Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "file"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 22H18C19.1046 22 20 21.1046 20 20V9.82843C20 9.29799 19.7893 8.78929 19.4142 8.41421L13.5858 2.58579C13.2107 2.21071 12.702 2 12.1716 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 2.5V9H19",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 17H15",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13H15",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9H9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "file-upload"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,6.52797748 L20,19.5 C20,20.8807119 18.8807119,22 17.5,22 L6.5,22 C5.11928813,22 4,20.8807119 4,19.5 L4,4.5 C4,3.11928813 5.11928813,2 6.5,2 L15.4720225,2 C15.6047688,1.99158053 15.7429463,2.03583949 15.8535534,2.14644661 L19.8535534,6.14644661 C19.9641605,6.25705373 20.0084195,6.39523125 20,6.52797748 Z M15,3 L6.5,3 C5.67157288,3 5,3.67157288 5,4.5 L5,19.5 C5,20.3284271 5.67157288,21 6.5,21 L17.5,21 C18.3284271,21 19,20.3284271 19,19.5 L19,7 L15.5,7 C15.2238576,7 15,6.77614237 15,6.5 L15,3 Z M16,3.70710678 L16,6 L18.2928932,6 L16,3.70710678 Z M12,16.2928932 L14.1464466,14.1464466 C14.3417088,13.9511845 14.6582912,13.9511845 14.8535534,14.1464466 C15.0488155,14.3417088 15.0488155,14.6582912 14.8535534,14.8535534 L11.9198269,17.7872799 C11.8307203,17.9246987 11.6759769,18.0156098 11.5,18.0156098 C11.3240231,18.0156098 11.1692797,17.9246987 11.0801731,17.7872799 L8.14644661,14.8535534 C7.95118446,14.6582912 7.95118446,14.3417088 8.14644661,14.1464466 C8.34170876,13.9511845 8.65829124,13.9511845 8.85355339,14.1464466 L11,16.2928932 L11,9.5 C11,9.22385763 11.2238576,9 11.5,9 C11.7761424,9 12,9.22385763 12,9.5 L12,16.2928932 L12,16.2928932 Z"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "pencil"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19H5V15.5L15.5 5L19 8.5L8.5 19Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.875 7.625L16.375 11.125",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "database"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12C16.5563 12 20.25 9.98528 20.25 7.5C20.25 5.01472 16.5563 3 12 3C7.44365 3 3.75 5.01472 3.75 7.5C3.75 9.98528 7.44365 12 12 12Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7.5V12C3.75 14.4844 7.44375 16.5 12 16.5C16.5562 16.5 20.25 14.4844 20.25 12V7.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12V16.5C3.75 18.9844 7.44375 21 12 21C16.5562 21 20.25 18.9844 20.25 16.5V12",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 9",
    id: "back-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.646446 4.14645C0.451184 4.34171 0.451184 4.65829 0.646446 4.85355L3.82843 8.03553C4.02369 8.2308 4.34027 8.2308 4.53553 8.03553C4.7308 7.84027 4.7308 7.52369 4.53553 7.32843L1.70711 4.5L4.53553 1.67157C4.7308 1.47631 4.7308 1.15973 4.53553 0.964466C4.34027 0.769204 4.02369 0.769204 3.82843 0.964466L0.646446 4.14645ZM11 4L1 4V5L11 5V4Z"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    id: "envelope"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 6V12.5C2 12.6326 2.05268 12.7598 2.14645 12.8536C2.24021 12.9473 2.36739 13 2.5 13H13.5C13.6326 13 13.7598 12.9473 13.8536 12.8536C13.9473 12.7598 14 12.6326 14 12.5V6L8 2L2 6Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6L9.09375 9.5H6.90625L2 6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59 29",
    id: "sad-icon"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 0.701658C16.8716 0.701658 17.6045 0.970701 18.1982 1.50879C18.8105 2.06543 19.1167 2.86328 19.1167 3.90234C19.1167 4.9414 18.8105 5.72998 18.1982 6.26806C17.6045 6.82471 16.8716 7.10303 15.9995 7.10303C15.146 7.10303 14.4224 6.82471 13.8286 6.26806C13.2349 5.72998 12.938 4.9414 12.938 3.90234C12.938 2.86328 13.2349 2.06543 13.8286 1.50879C14.4224 0.970701 15.146 0.701658 15.9995 0.701658ZM40.5752 0.729491C41.4473 0.729491 42.1802 0.998534 42.7739 1.53662C43.3862 2.09326 43.6924 2.89111 43.6924 3.93018C43.6924 4.96924 43.3862 5.75781 42.7739 6.2959C42.1802 6.85254 41.4473 7.13086 40.5752 7.13086C39.7217 7.13086 38.998 6.85254 38.4043 6.2959C37.8105 5.75781 37.5137 4.96924 37.5137 3.93017C37.5137 2.89111 37.8105 2.09326 38.4043 1.53662C38.998 0.998534 39.7217 0.729491 40.5752 0.729491Z",
    fill: "#787680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4702 14.2842L29.7485 14.2842C33.7935 14.2842 37.4487 14.7388 40.7144 15.6479C43.9985 16.5571 46.8745 17.7168 49.3423 19.127C51.8101 20.5371 53.8511 22.0215 55.4653 23.5801C57.0981 25.1387 58.2764 26.5767 59 27.894L55.6045 28.9795C54.7695 27.8848 53.6191 26.7715 52.1533 25.6396C50.6875 24.5264 48.8877 23.4966 46.7539 22.5503C44.6201 21.6226 42.1431 20.8711 39.3228 20.2959C36.5024 19.7207 33.3296 19.4331 29.8042 19.4331L29.4145 19.4331C25.8892 19.4331 22.707 19.7207 19.8682 20.2959C17.0479 20.8711 14.5615 21.6226 12.4092 22.5503C10.2568 23.4966 8.4292 24.5264 6.92627 25.6396C5.40478 26.7715 4.19873 27.8848 3.3081 28.9795L0.190917 27.894C0.91455 26.5767 2.09277 25.1387 3.72558 23.5801C5.33984 22.0215 7.38086 20.5371 9.84863 19.127C12.2979 17.7168 15.1646 16.5571 18.4487 15.6479C21.7329 14.7388 25.4067 14.2842 29.4702 14.2842Z",
    fill: "#787680"
  })))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 8",
    id: "back-arrow-small"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.146446 3.64645C-0.0488157 3.84171 -0.0488157 4.15829 0.146446 4.35355L3.32843 7.53553C3.52369 7.7308 3.84027 7.7308 4.03553 7.53553C4.2308 7.34027 4.2308 7.02369 4.03553 6.82843L1.20711 4L4.03553 1.17157C4.2308 0.976311 4.2308 0.659729 4.03553 0.464466C3.84027 0.269204 3.52369 0.269204 3.32843 0.464467L0.146446 3.64645ZM8.5 3.5L0.5 3.5L0.5 4.5L8.5 4.5L8.5 3.5Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.1df63387889bd041393335b32f35ba44.svg";
export { ForwardRef as ReactComponent };